<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('table_search') || '校验单号/采购单号/订单号/供应商 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditPage', { pageType: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
            <slot :form="form" />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-drawer
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :visible.sync="advqueryDialogVisible"
      size="600px"
      :close-on-click-modal="false"
      append-to-body
      :with-header="false"
    >
      <div class="d-flex" style="justify-content: space-between; margin: 20px;">
        <div style="color: #101010;font-size: 14px;">
          高级搜索
        </div>
        <div>
          <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="closeAdvqueryDialog">
              {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
            </el-button>
            <el-button size="mini" type="warning" @click="reset">
              {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
            </el-button>
            <el-button size="mini" type="primary" @click="advquery">
              {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
            </el-button>
          </span>
        </div>
      </div>

      <div class="ml-4 mr-4">
        <el-form
          ref="form"
          :model="form"
          label-position="right"
          label-width="100px"
          size="mini"
        >
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_fabricInspectionStatus') || '单据状态'"
              >
                <DictCheckBox
                  :checkList="form.statusList"
                  url="/sys/common/dict/system"
                  :body="{
                    dictType: 'fabricInspectionStatus',
                  }"
                  @change="statusChange"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_auditResultType') || '审核结果'"
              >
                <DictCheckBox
                  :checkList="form.auditResultTypeList"
                  url="/sys/common/dict/system"
                  :body="{
                    dictType: 'mrpFabricAuditResultType',
                  }"
                  @change="auditResultTypeChange"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_inspectionNo') || '检验单号'"
              >
                <el-input
                  v-model.trim="form.inspectionNo"
                  :placeholder="
                    $l('form_please_inspectionNo') || '请输入检验单号'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_purchaseFabricNo') || '采购单号'"
              >
                <el-input
                  v-model.trim="form.purchaseFabricNo"
                  :placeholder="
                    $l('form_please_purchaseFabricNo') || '请输入采购单号'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_originOrderNo') || '源头订单号'"
              >
                <el-input
                  v-model.trim="form.originOrderNo"
                  :placeholder="
                    $l('form_please_originOrderNo') || '请输入源头订单号'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item :label="$l('form_label_scmName') || '供方'">
                <dict-select
                  :placeholder="$l('form_please_scmName') || '请选择供方...'"
                  size="mini"
                  clearable
                  filterable
                  multiple
                  v-model="form.scmCodeList"
                  url="/master/common/dict/scmPartners"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_purchaserEntity') || '需方'">
                <dict-select
                  v-model="form.purchaserEntityCodeList"
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'orderSource' }"
                  :placeholder="
                    $l('form_please_purchaserEntity') || '请选择需方...'
                  "
                  size="mini"
                  style="width: 100%"
                  filterable
                  clearable
                  multiple
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_buyerCodeList') || '采购人员'"
              >
                <dict-select
                  v-model="form.buyerCodeList"
                  multiple
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('form_please_buyerCodeList') || '请选择采购人员...'
                  "
                  size="mini"
                  clearable
                  style="width: 100%"
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_reporterCodeList') || '质检员'"
              >
                <!-- <dict-select
                  v-model="form.reporterCodeList"
                  multiple
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('form_please_reporterCodeList') || '请选择质检员...'
                  "
                  size="mini"
                  clearable
                  style="width: 100%"
                  filterable
                  @loaded="loadedReporter"
                  @change="changeReporter"
                ></dict-select> -->
                <el-select
                  v-model="form.reporterNameList"
                  filterable
                  multiple
                  allow-create
                  default-first-option
                  style="width: 100%"
                  :placeholder="
                    $l('form_please_reporterNameList') || '请输入质检员'
                  "
                  :no-data-text="
                    $l('form_please_reporterNameList') || '请输入质检员'
                  "
                >
                  <el-option
                    v-for="item in []"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item :label="$l('form_label_fabricNo') || '物料编码'">
                <el-input
                  clearable
                  v-model="form.fabricNo"
                  size="mini"
                  style="width: 100%"
                  :placeholder="$l('form_please_fabricNo') || '请输入物料编码'"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_fabricName') || '物料名称'">
                <el-input
                  clearable
                  v-model="form.fabricName"
                  :placeholder="
                    $l('form_please_fabricName') || '请输入物料名称'
                  "
                  size="mini"
                  style="width: 100%"
                >
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_fabricContent') || '规格型号'"
                prop="fabricContent"
              >
                <el-input
                  clearable
                  v-model="form.fabricContent"
                  :placeholder="
                    $l('form_please_fabricContent') || '请输入规格型号'
                  "
                  size="mini"
                  style="width: 100%"
                >
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_inspectionResult') || '判定结果'"
              >
                <dict-select
                  v-model="form.inspectionResultList"
                  url="/sys/common/dict/system"
                  :body="{ dictType: 'inspectionResult' }"
                  :placeholder="
                    $l('form_please_inspectionResult') || '请选择判定结果...'
                  "
                  size="mini"
                  style="width: 100%"
                  filterable
                  clearable
                  multiple
                ></dict-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-row>
                <el-form-item
                  :label="$l('form_label_arrivalDate') || '实际到料日期'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginArrivalDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('form_please_arrivalDate') || '请选择实际到料日期'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endArrivalDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('form_please_arrivalDate') || '请选择实际到料日期'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-row>
                <el-form-item
                  :label="$l('form_label_inspectionDate') || '检验日期'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginInspectionDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('form_please_inspectionDate') || '请选择检验日期'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endInspectionDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('form_please_inspectionDate') || '请选择检验日期'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>

            <el-col :span="24">
              <el-row>
                <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginCreateTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endCreateTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-form-item
                  :label="
                    $l('INDEX.form_label_modification_time') || '修改时间'
                  "
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginModifyTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endModifyTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>

            <el-col :span="24">
              <el-form-item :label="$l('form_label_createBy') || '创建人'">
                <dict-select
                  v-model="form.createByList"
                  multiple
                  url="/master/common/dict/baseUserSelect"
                  size="mini"
                  clearable
                  style="width: 100%"
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_modifyBy') || '修改人'">
                <dict-select
                  v-model="form.modifyByList"
                  multiple
                  url="/master/common/dict/baseUserSelect"
                  size="mini"
                  clearable
                  style="width: 100%"
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import DictCheckBox from '@/views/factory/components/dict-check-box'

// 初始表单
const initForm = {
  keyword: '',
  statusList: ['S', 'N', 'Q', 'R', 'T'],
}
export default {
  components: { DictCheckBox },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      reporterList: [],
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    loadedReporter(val) {
      this.reporterList = val
    },
    changeReporter(val) {
      if (!val || val.length === 0) {
        this.form.reporterNameList = []
        return
      }
      this.form.reporterNameList = this.reporterList
        .filter((item) => val.includes(item.value))
        .map((item) => item.label)
    },
    statusChange(val) {
      if (!val || val.length === 0) {
        this.form.statusList = []
      } else {
        this.form.statusList = val
      }
    },
    auditResultTypeChange(val) {
      if (!val || val.length === 0) {
        this.form.auditResultTypeList = []
      } else {
        this.form.auditResultTypeList = val
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
